
import { useAuth } from '../components/common/use-auth';
import { AzurePaths, GetAzurePath } from '../components/common/Constants';
import { useRouter } from '../components/common/use-router';
import React from 'react';

export default function Logout() {
    const { user, signout } = useAuth();
    const router = useRouter();

    const  logout =  async () => {
        await signout();
        router.push("/login");
      };
    
    React.useEffect(async () => {
        await logout();
    }, []);
    return <div></div>
}